import React from "react";
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar.js";
import "./CommonContainerStyles.css";
import Tabs from "../../Components/Tabs/Tabs";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CollegeAvatar from "../../Components/UserAvatar/CollegeAvatar";
import StickyButton from "../../Components/Buttons/StickyButton.js";

function TeacherInformationContainer(props) {
  // add isViewAsPersonnel to check for personnel user - lieh
  const {
    header,
    tabs,
    handleSubmit,
    user,
    uploadAvatar,
    isViewAsPersonnel,
    viewbookings,
  } = props;

  const menuLogoBar = isViewAsPersonnel ? (
    <SwitchMenuBar
      isViewAsPersonnel={true}
      isTeacherInfo={true}
      viewbookings={viewbookings}
    />
  ) : (
    <SwitchMenuBar
      isViewAsCollege={true}
      isTeacherInfo={true}
      viewbookings={viewbookings}
    />
  );

  return (
    <div className="page-container-outer">
      <div className="menu-logo-bar">
        {/* <SwitchMenuBar isViewAsTeacher={true} isTeacherInfo={true} /> */}
        {/* <SwitchMenuBar isViewAsCollege={true} isTeacherInfo={true} /> */}
        {menuLogoBar}
      </div>
      <div className="page-container-main bg-photoregister">
        <div className="bg-gradient page-container-bg"></div>
        <div className="page-container-header">
          <div className="page-container-header-inner college-form-header">
            <CollegeAvatar icon={user ? user.photo : null}>
              <span
                className="mdi mdi-camera home-upload-avatar-button"
                onClick={uploadAvatar}
              ></span>
            </CollegeAvatar>
            <h1>{header}</h1>
          </div>
        </div>
        <div className="page-container-inner">
          {tabs ? <Tabs tabs={tabs} /> : null}
          <form>
            <div className="container px-0">{props.children}</div>
          </form>
          <ConfirmButton type="submit" onClick={handleSubmit}>
            Submit
          </ConfirmButton>
        </div>
      </div>
      {/* <StickyButton/> */}
    </div>
  );
}

export default TeacherInformationContainer;
